import { connect } from 'react-redux'
import List from '../_List'
import { selectMission } from '../../../../actions'


const toggleDialog = (id,toggleOpen,dispatch) =>{
  console.log(`CLICK ${id}`)
  // DISPATCH
  dispatch(selectMission({id: id}))
  toggleOpen()
}


const mapStateToProps = state => ({
  list_name: 'Misiones',
  empty_message: '¡No has completado ninguna misión!',
  items: state.user.missions,
})

const mapDispatchToProps = dispatch => ({
  toggleDialog: (id,toggleOpen) => toggleDialog(id,toggleOpen,dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/components/Main/Profile/Missions/index.jsx